import { RxCustomerAPI } from '@driftt/dapper'
import { CUSTOMER_API } from 'constants/ResourcesConstants'
import { serializeObject, getAuthorizationHeader } from 'utils/Helpers'
import { X_WWW_FORM } from 'constants/RequestContentType'

export const api = {

  fetchOAuthCode({ redirect_uri, client_id }) {
    return fetch(`${ CUSTOMER_API }/oauth/auth`, {
      method: 'POST',
      headers: _.extend({ 'Content-Type': X_WWW_FORM }, getAuthorizationHeader()),
      body: serializeObject({
        response_type: 'code',
        client_id,
        access_type: 'offline',
        redirect_uri
      })
    })
    .then(res => res.json())
  },

  fetchOAuthAppInfo({ client_id }) {
    return RxCustomerAPI.get(`/oauth/applications?clientId=${client_id}`)
      .map(res => res.response)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/externalApp/api.js